/**
 * Highlight "Sales" menu items in red across all header menus
 */

function highlightSalesMenuItems() {
  // List of selectors to search for menu items
  const selectors = [
    '.header__menu-item',           // Inline desktop menu
    '.menu-drawer__menu-link',       // Mobile menu drawer
    '.menu-drawer__submenu-list-link', // Mobile submenu
    '.mega-menu__column-heading',   // Mega menu headings
    '.mega-menu__column-list-link', // Mega menu links
    '.mega-menu__tab span',         // Mega menu tabs
    '.header__submenu a',           // Regular submenu
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(element => {
      // Check if element contains "Sales" text (case-insensitive)
      const text = element.textContent?.trim() || '';
      if (text.toLowerCase() === 'sales' || text.toLowerCase().includes('sales')) {
        // Find the span or direct text node and apply color
        const span = element.querySelector('span') || element;
        span.style.color = '#d42426';
      }
    });
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', highlightSalesMenuItems);
} else {
  highlightSalesMenuItems();
}

// Re-run when Shopify sections load dynamically
document.addEventListener('shopify:section:load', highlightSalesMenuItems);

// Re-run periodically for dynamically added content
const observer = new MutationObserver(highlightSalesMenuItems);
observer.observe(document.body, { 
  childList: true, 
  subtree: true,
  attributes: false
});
